package co.maytes.standupbot.dashboard.lib.api

sealed interface Result<out T, out E> {
    data class Ok<out T>(val value: T) : Result<T, Nothing>
    data class Err<out E>(val error: E) : Result<Nothing, E>
}

inline fun <T, E> Result<T, E>.onOk(block: (T) -> Unit): Result<T, E> = apply {
    if (this is Result.Ok) block(value)
}

inline fun <T, E> Result<T, E>.onErr(block: (E) -> Unit): Result<T, E> = apply {
    if (this is Result.Err) block(error)
}

inline fun <T, U, E> Result<T, E>.map(transform: (T) -> U): Result<U, E> = when (this) {
    is Result.Ok -> Result.Ok(transform(value))
    is Result.Err -> this
}
